<template>
  <div>
    <v-app-bar
      id="app-bar"
      fixed
      app
      clipped-right
      color="background"
      flat
      height="75"
    >
      <v-app-bar-nav-icon
        @click.stop="
          $store.commit('set', {
            varName: 'showDrawer',
            value: !$store.state.showDrawer
          })
        "
        class="ml-2"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title
        class="hidden-sm-and-down font-weight-light mr-8 "
        v-text="$t($route.name)"
      />
      <slot name="extraContent" />
      <v-spacer />
      <v-menu
        bottom
        left
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="mx-2"
            min-width="0"
            text
            v-bind="attrs"
            v-on="on"
            @click="toggleNotifications"
          >
            <v-badge
              v-if="notifications.length > 0"
              color="primary"
              overlap
              bordered
            >
              <template v-slot:badge>
                <span>{{ notifications.length }}</span>
              </template>

              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
            <v-icon v-else>mdi-bell-outline</v-icon>
          </v-btn>
        </template>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="notificationsDrawer"
      app
      right
      clipped
      absolute
      floating
      permanent
      v-if="notificationsDrawer"
      width="300px"
    >
      <v-list
        :tile="false"
        v-if="notifications.length > 0"
        class="overflow-y-auto mx-3"
        two-line=""
      >
        <div v-for="(notification, i) in notifications" :key="`item-${i}`">
          <div class="body-1">
            <v-row align="center" class="mr-1">
              <v-col cols="1">
                <Avatars
                  class="mr-3"
                  height="20px"
                  :seed="notification.activity.userId"
              /></v-col>
              <v-col cols="9">
                {{ notification.text }}<br /><span class="grey--text">
                  {{ timeTo(notification.activity.date) }}</span
                >
              </v-col>
              <v-col cols="1">
                <v-btn icon @click.prevent="removeNotification(notification)">
                  <v-icon color="red">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-list>
      <v-container fluid class="full-width" v-else>
        <v-row align="center" justify="center">
          <v-col align-self="center">
            <div class="text-center title">
              {{ $t("All Done") }}
            </div>
          </v-col>
        </v-row>
      </v-container>
      <template v-slot:append>
        <div class="d-flex justify-end mr-7 my-4 bottom-0">
          <v-btn
            @click="dismissAll"
            class="primary--text  my-4"
            v-text="$t('Dismiss all')"
            outlined
          />
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
// Utilities
import { mapState, mapMutations } from "vuex";
import router from "@/router/index";
import Activity from "@/model/activity";
import Avatars from "@/views/dashboard/components/Avatars";

export default {
  name: "DashboardCoreAppBar",

  components: { Avatars },

  data() {
    return { notificationsDrawer: false };
  },

  computed: {
    ...mapState(["drawer"]),
    notifications() {
      let activities = this.$store.state.activities.filter(function(el) {
        return el.dismissed != true;
      });
      let notifications = [];
      let activitiesObj = activities.map(activity =>
        Activity.fromMap(activity)
      );
      activitiesObj.forEach(activity => {
        if (activity.type == "callwaiter") {
          let location = this.$store.getters.locations.filter(
            location => location.id === activity.location
          )[0];
          notifications.push({
            activity: activity,
            show: true,
            text: this.$t("Waiter to {locationName}", {
              locationName: location.name
            })
          });
        }
        if (activity.type == "readMenu") {
          let location = this.$store.getters.locations.filter(
            location => location.id === activity.location
          )[0];
          notifications.push({
            activity: activity,
            show: true,
            text: this.$t("New client at {locationName}", {
              locationName: location.name
            })
          });
        }
        if (activity.type == "newOrder") {
          let location = this.$store.getters.locations.filter(
            location => location.id === activity.location
          )[0];
          notifications.push({
            activity: activity,
            show: true,
            text: this.$t("New order at {locationName}", {
              locationName: location.name
            })
          });
        }
        if (activity.type == "cash") {
          let location = this.$store.getters.locations.filter(
            location => location.id === activity.location
          )[0];
          notifications.push({
            activity: activity,
            show: true,
            text: this.$t("Cash pay at {locationName}", {
              locationName: location.name
            })
          });
        }
        if (activity.type == "creditCard") {
          let location = this.$store.getters.locations.filter(
            location => location.id === activity.location
          )[0];
          notifications.push({
            activity: activity,
            show: true,
            text: this.$t("Credit card pay at {locationName}", {
              locationName: location.name
            })
          });
        }
      });

      return notifications;
    }
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER"
    }),

    toggleNotifications() {
      this.notificationsDrawer = !this.notificationsDrawer;
    },

    timeTo(date) {
      var delta = Math.round((+new Date() - date) / 1000);

      var minute = 60,
        hour = minute * 60,
        day = hour * 24;

      var fuzzy;

      if (delta < minute) {
        fuzzy = this.$t("Less than a minute ago");
      } else if (delta < 2 * minute) {
        fuzzy = this.$t("1 minute ago");
      } else if (delta < hour) {
        fuzzy = this.$t("{mins} minutes ago", {
          mins: Math.floor(delta / minute)
        });
      } else if (Math.floor(delta / hour) == 1) {
        fuzzy = "1 hour ago";
      } else if (delta < day) {
        fuzzy = this.$t("{hour} hours ago", {
          hour: Math.floor(delta / hour)
        });
      } else if (delta < day * 2) {
        fuzzy = this.$t("yesterday");
      } else if (delta < day * 7) {
        fuzzy = this.$t("{day} days ago", {
          day: Math.floor(delta / day)
        });
      } else if (delta > day * 7) {
        fuzzy = this.$t("{day} days ago", {
          day: Math.floor(delta / day)
        });
      }
      return fuzzy;
    },
    dismissAll() {
      this.notifications.forEach(notification => {
        notification.activity.dismissed = true;
        notification.activity.save();
      });
    },
    goToSettings() {
      router.replace("/settings");
    },

    removeNotification(notification) {
      notification.activity.dismissed = true;
      notification.activity.save();
    }
  }
};
</script>
